module.exports = __webpack_public_path__ + "static/media/ic_filter.83085e30.svg";